export default "__VITE_ASSET__DSADzUPi__"